import React from 'react';
import { Grid, ListItemIcon } from '@mui/material';
import AddWorkShiftsEnrollment from '../Modal/AddWorkShiftsEnrollment';
import AddCustomizedSchedule from '../Modal/AddCustomizedSchedule';
import dayId from '../../../../../hooks/dayId';
import DeleteModal from '../../../../Modals/DeleteModal';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import CustomCardContainer from '../../../../../components/CustomCardContainer';
import ButtonSubAction from '../../../../../components/buttons/ButtonSubAction';
import CustomListContainer from '../../../../../components/CustomListContainer';
import CustomListItem from '../../../../../components/CustomListItem';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import AccessRightsApp from '../Functionality/AccessRightsApp';
import {TrashOutlineIcon} from '../../../../../components/buttons/IconButtons';

const Step4AccessRights = ({
    userData,
    workShiftsList,
    setWorkShiftsList,
    customizedList,
    setCustomizedList,
    contractId,
    contractorItemId,
    isEditable,
    cardContentClass='h-320px'
}) => {
    const {
        t,
        selectWorkShiftForDelete,
        setSelectWorkShiftForDelete,
        setIsAllCheckedWorkShift,
        selectCustomizedForDelete,
        setSelectCustomizedForDelete,
        setIsAllCheckedCustomized,
        addWorkShiftsDialogShow,
        setAddWorkShiftsDialogShow,
        addCustomizedDialogShow,
        setAddCustomizedDialogShow,
        deleteWorkShiftShow,
        setDeleteWorkShiftShow,
        deleteSingleWorkShiftShow,
        setDeleteSingleWorkShiftShow,
        singleWorkShiftForDelete,
        setSingleWorkShiftForDelete,
        deleteCustomizedShow,
        setDeleteCustomizedShow,
        deleteSingleCustomizedShow,
        setDeleteSingleCustomizedShow,
        singleCustomizedForDelete,
        setSingleCustomizedForDelete,
        deleteSelectedCustomized,
        deleteSelectedManageUser,
        handleCheckboxChangeCustomized,
        handleCheckboxChangeWorkShift,
        handleRemoveAllCustomized,
        handleRemoveAllWorkShifts,
        showOptions
    } = AccessRightsApp({
        userData,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        contractorItemId,
        contractId,
        isEditable,
    });

    return (
        <>
            <div className='access-rights-enrollment mt-4'>
              <div className='row g-3'>
                   <div className='col-12 col-xxl-7'>
                        <div className='container-top-right-btns mb-1'>
                            {showOptions && (
                                <ButtonAction
                                    id='btn_s4ar_delete_work_shift'
                                    name='delete'
                                    className='btn-icon-delete'
                                    disabled={selectWorkShiftForDelete?.length === 0}
                                    Icon={TrashOutlineIcon}
                                    onClick={() => {
                                        setDeleteWorkShiftShow(true);
                                    }}
                                />
                            )}
                        </div>

                        <CustomCardContainer
                            title={'work_shifts'}
                            cardContentClass={cardContentClass}
                            subtitle={
                                showOptions && (
                                    <CustomCheckbox
                                        id={'cb_s4ar_de_select_all'}
                                        trans={t('de_/_select_all')}
                                        name={'deSelectAll'}
                                        disabled={workShiftsList.length === 0}
                                        checked={
                                            selectWorkShiftForDelete.length > 0 &&
                                            workShiftsList.length === selectWorkShiftForDelete.length
                                        }
                                        onChange={handleRemoveAllWorkShifts}
                                    />
                                )
                            }
                            actions={
                                showOptions && (
                                    <ButtonSubAction
                                        id='btn_s4ar_all_add_more'
                                        name='add_more'
                                        onClick={() => {
                                            setAddWorkShiftsDialogShow(true);
                                        }}
                                    />
                                )
                            }
                        >
                            <CustomListContainer>
                                {workShiftsList?.map((element, index) => (
                                    <CustomListItem
                                        display={'flex'}
                                        key={index}
                                        text={!showOptions ? element.name : ''}
                                        actions={
                                            showOptions && (
                                                <ButtonIcon
                                                    id='btn_s4ar_all_delete'
                                                    Icon={TrashOutlineIcon}
                                                    onClick={() => {
                                                        setDeleteSingleWorkShiftShow(true);
                                                        setSingleWorkShiftForDelete([index]);
                                                    }}
                                                    title={''}
                                                    className='btn-background-transparent'
                                                    iconProps={'btn-icon-svg-red btn-icon-svg-12px'}
                                                />
                                            )
                                        }
                                    >
                                        {showOptions && (
                                            <ListItemIcon>
                                                <CustomCheckbox
                                                    id={'cb_s4ar_work_shift_all_' + index}
                                                    trans={element?.name}
                                                    fontSize={'10px'}
                                                    name={'workShift' + index}
                                                    checked={selectWorkShiftForDelete?.includes(index)}
                                                    onChange={(e) =>
                                                        handleCheckboxChangeWorkShift({
                                                            target: { ...e.target, id: parseInt(index) },
                                                        })
                                                    }
                                                />
                                            </ListItemIcon>
                                        )}
                                    </CustomListItem>
                                ))}
                            </CustomListContainer>
                        </CustomCardContainer>
                    </div>

                   <div className='col-12 col-xxl-5'>
                        <div className='container-top-right-btns mb-1'>
                            {showOptions && (
                                <ButtonAction
                                    id='btn_s4ar_delete_customized'
                                    name='delete'
                                    className='btn-icon-delete'
                                    disabled={selectCustomizedForDelete?.length === 0}
                                    Icon={TrashOutlineIcon}
                                    onClick={() => {
                                        setDeleteCustomizedShow(true);
                                    }}
                                />
                            )}
                        </div>

                        <CustomCardContainer
                            title={'customized'}
                            cardContentClass={cardContentClass}
                            subtitle={
                                showOptions && (
                                    <CustomCheckbox
                                        id={'cb_s4ar_de_select_customized'}
                                        trans={t('de_/_select_all')}
                                        name={'deSelectCustomized'}
                                        disabled={customizedList.length === 0}
                                        checked={
                                            selectCustomizedForDelete.length > 0 &&
                                            customizedList.length === selectCustomizedForDelete.length
                                        }
                                        onChange={handleRemoveAllCustomized}
                                    />
                                )
                            }
                            actions={
                                showOptions && (
                                    <ButtonSubAction
                                        id='btn_s4ar_customized_add_more'
                                        name='add_more'
                                        onClick={() => {
                                            setAddCustomizedDialogShow(true);
                                        }}
                                    />
                                )
                            }
                        >
                            <CustomListContainer>
                                {customizedList.map(
                                    (element, index) =>
                                        element.added && (
                                            <CustomListItem
                                                display={'flex'}
                                                text={
                                                    !showOptions
                                                        ? `${dayId(parseInt(element?.dayId))}, ${element?.from} - ${
                                                              element?.to
                                                          }, ${element?.zoneName}`
                                                        : ''
                                                }
                                                key={index}
                                                actions={
                                                    showOptions && (
                                                        <ButtonIcon
                                                            id='btn_s4ar_customized_delete'
                                                            Icon={TrashOutlineIcon}
                                                            onClick={() => {
                                                                setDeleteSingleCustomizedShow(true);
                                                                setSingleCustomizedForDelete([index]);
                                                            }}
                                                            title={''}
                                                            className='btn-background-transparent'
                                                            iconProps={'btn-icon-svg-red btn-icon-svg-12px'}
                                                        />
                                                    )
                                                }
                                            >
                                                {showOptions && (
                                                    <ListItemIcon>
                                                        <CustomCheckbox
                                                            id={'cb_s4ar_work_shift_customized_' + index}
                                                            trans={`${dayId(parseInt(element?.dayId))}, ${
                                                                element?.from
                                                            } - ${element?.to}, ${element?.zoneName}`}
                                                            fontSize={'10px'}
                                                            name={'workShift' + index}
                                                            checked={selectCustomizedForDelete?.includes(index)}
                                                            onChange={(e) =>
                                                                handleCheckboxChangeCustomized({
                                                                    target: { ...e.target, id: parseInt(index) },
                                                                })
                                                            }
                                                        />
                                                    </ListItemIcon>
                                                )}
                                            </CustomListItem>
                                        ),
                                )}
                            </CustomListContainer>
                        </CustomCardContainer>
                    </div>
                </div>
            </div>
            <AddWorkShiftsEnrollment
                open={addWorkShiftsDialogShow}
                onClose={() => {
                    setAddWorkShiftsDialogShow(false);
                }}
                workshiftsList={workShiftsList}
                setWorkshiftsList={setWorkShiftsList}
            />
            <AddCustomizedSchedule
                open={addCustomizedDialogShow}
                onClose={() => {
                    setAddCustomizedDialogShow(false);
                }}
                customizedList={customizedList}
                setCustomizedList={setCustomizedList}
            />
            <DeleteModal
                show={deleteWorkShiftShow}
                onHide={() => setDeleteWorkShiftShow(false)}
                onClickFn={() => deleteSelectedManageUser(selectWorkShiftForDelete)}
                data={selectWorkShiftForDelete}
                isReset={setSelectWorkShiftForDelete}
                isAllReset={setIsAllCheckedWorkShift}
                description={'are_you_sure_you_want_to_remove'}
                title_modal={t('remove')}
                element_modal={t('workshifts')}
            />
            <DeleteModal
                show={deleteSingleWorkShiftShow}
                onHide={() => setDeleteSingleWorkShiftShow(false)}
                onClickFn={() => deleteSelectedManageUser(singleWorkShiftForDelete)}
                data={singleWorkShiftForDelete}
                title_modal={t('remove')}
                description={'are_you_sure_you_want_to_remove'}
                element_modal={t('workshift')}
            />
            <DeleteModal
                show={deleteCustomizedShow}
                onHide={() => setDeleteCustomizedShow(false)}
                onClickFn={() => deleteSelectedCustomized(selectCustomizedForDelete)}
                data={selectCustomizedForDelete}
                isReset={setSelectCustomizedForDelete}
                isAllReset={setIsAllCheckedCustomized}
                title_modal={t('remove')}
                description={'are_you_sure_you_want_to_remove'}
                element_modal={t('customizeds_access')}
            />
            <DeleteModal
                show={deleteSingleCustomizedShow}
                onHide={() => setDeleteSingleCustomizedShow(false)}
                onClickFn={() => deleteSelectedCustomized(singleCustomizedForDelete)}
                data={singleCustomizedForDelete}
                title_modal={t('remove')}
                description={'are_you_sure_you_want_to_remove'}
                element_modal={t('customized_access')}
            />
        </>
    );
};

export default Step4AccessRights;
